import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { ComponentLoader } from 'cat-ecommerce-alloy';
import cx from 'classnames';
import styles from './ShoppingCartLoader.module.scss';

const ShoppingCartLoader = () => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);

  return (
    <div
      className={cx(
        styles['shopping-cart-page__loader-wrapper'],
        'd-flex align-items-center'
      )}
    >
      <div className="position-relative w-100">
        <ComponentLoader size={isLG ? 'large' : 'small'} />
      </div>
    </div>
  );
};

export default ShoppingCartLoader;
